module.exports = ".uppercase { text-transform: uppercase; }\n\n.progress-number { position: absolute; top: 85px; font-size: 3em; left: 30%; color: #ccc; }\n\n.progress { height: 3px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/progress/progress.component.css
// module id = ./src/app/shared/progress/progress.component.css
// module chunks = main